import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cart/giftbox.png")